<div class="no-access-container">
    <div class="card shadow-lg p-5 text-center rounded-4 border-0">
        <div class="mb-4">
            <span class="material-symbols-outlined text-colonial display-1">lock</span>
        </div>
        <h1 class="h3 mb-3 fw-bold">Acceso restringido</h1>
        <p class="text-muted mb-4 fs-5">
            Todavía no tienes acceso a esta aplicación
        </p>
        <button (click)="logout()" class="btn bg-colonial btn-secondary btn-lg rounded-pill px-5">
            Cerrar Sesión
        </button>
    </div>
</div>